const ProfilePanel = ({ children }) => (
  <div className="rounded-2xl border border-gray-200 bg-white p-6 sm:p-10">
    {children}
  </div>
);

export default ProfilePanel;
